import "./Product.scss";
import "./_RecentlyViewedSide.scss";
import { AddToCartPage } from "./_AddToCartPage";
import { CookieManager } from '@Utilities/CookieManager';
import { BackInStock } from "./_BackInStock";
import { EngagementProvider } from "@Base/Engagement/Engagement";
import { Gallery } from "./_Gallery";
import { ImageZoom } from "./_ImageZoom";
import { PreOrder } from './_Preorder';
import { Purchase } from './_Purchase';
import { Purim } from "./_Purim";
import { Reviews } from "./_Reviews";
import { SizeChart } from "./_SizeChart";
import { SocialProof } from "./_SocialProof";
import { Video } from "./_Video";

export class BaseProduct
{
	public AddToCartPage: AddToCartPage;
	public BackInStock: BackInStock;
	public Engagement: EngagementProvider;
	public Gallery: Gallery;
	public ImageZoom: ImageZoom;
	public PreOrder: PreOrder;
	public Purchase: Purchase;
	public Purim: Purim;
	public Reviews: Reviews;
	public SizeChart: SizeChart;
	public SocialProof: SocialProof;
	public Video: Video;

	constructor()
	{
		if (window.location.href.toLowerCase().indexOf("/addtocart/") > -1)
		{
			this.InitializeAddToCartPage();
		}
		else
		{
			this.Initialize();
		}
	}

	public Initialize(): void
	{
		this.BackInStock = new BackInStock();
		this.Engagement = new EngagementProvider();
		this.Gallery = new Gallery();
		this.ImageZoom = new ImageZoom(this.Gallery);
		this.Purim = new Purim();
		this.Reviews = new Reviews();
		this.SizeChart = new SizeChart();
		this.SocialProof = new SocialProof();
		this.Video = new Video();

		this.AddRecentItem();
		this.BindForms();

		const catalogId = CookieManager.GetCookie("VISITOR_v1", "DomainProjectID");
		if (catalogId == "13")
		{
			window.addEventListener("load", () =>
			{
				this.Engagement.PostProductTagToAttentive();
			});
		}
	}

	public InitializeAddToCartPage(): void
	{
		import(/* webpackChunkName: "atcPage" */"./_AddToCartPage")
			.then((atcPage) =>
			{
				this.AddToCartPage = new atcPage.AddToCartPage();
			})
			.catch((error) =>
			{
				console.log(error);
			});
	}

	private AddRecentItem = (): void =>
	{
		const productIDEl = document.querySelector("input[name='ProductID']") as HTMLInputElement;

		if (productIDEl !== null)
		{
			const productID = productIDEl.value;
			const RecentCookie = CookieManager.Cookies.RecentItems;
			const recents = CookieManager.GetCookie(RecentCookie.Key, RecentCookie.RecentItems);
			let products = [];
			let exists = false;

			// Setting to 5 to allow for the PDP/ATC to contain itself in the list.
			const maxRecents = 5;
			let extras = 0;
			const expirationDays = 365;

			if (recents.length > 0)
			{
				if (recents.indexOf(",") > -1)
				{
					products = recents.split(",");
				}
				else
				{
					products.push(recents);
				}
			}

			// See if the product already exists
			for (let i = 0; i < products.length; i++)
			{
				if (products[i] === productID)
				{
					exists = true;
					break;
				}
			}

			if (!exists)
			{
				// Add it to the top of the list.
				products.unshift(productID);
			}

			extras = products.length - maxRecents;
			if (extras > 0)
			{
				// Remove extras from the top of the list so we stay at the max.
				products.splice(maxRecents, extras);
			}

			CookieManager.SetInCookie(RecentCookie.Key, RecentCookie.RecentItems, products.join(","), expirationDays);
		}
	};

	private BindForms = (): void =>
	{
		const frmProduct = document.getElementById("frmProduct") as HTMLFormElement;
		const frmPreOrder = document.getElementById("frmPreOrder") as HTMLFormElement;

		if (frmProduct !== null)
		{
			this.Purchase = new Purchase(frmProduct);
		}

		if (frmPreOrder !== null)
		{
			this.PreOrder = new PreOrder(frmPreOrder);
		}
	};
}